import * as React from "react";
const SvgChartPie20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 .1h-.9v9.8h9.8V9A8.9 8.9 0 0 0 9 .1Zm.9 8V1.957A7.104 7.104 0 0 1 16.044 8.1H9.9ZM0 10c0-3.728 2.55-6.86 6-7.748v2.09A6 6 0 1 0 13.659 12h2.089A8 8 0 0 1 0 10Z",
      clipRule: "evenodd"
    })
  );
export default SvgChartPie20Px;
